import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pallete from './assets/colors'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({

    icons: {
        iconfont: 'mdi'
    },

    theme: {
        themes: {
          light: {
            primary: pallete.colors.primary,
            secondary: pallete.colors.secundary,
            danger: pallete.colors.danger,
            accent: pallete.colors.accent,
            
          },
          dark: {
            primary: colors.blue.lighten3,
          },
        },
      },

})


